import React, {
  createContext,
  useEffect,
  useState,
  useMemo,
  useCallback,
  useContext,
} from "react";
import { profileFetcher } from "../api/requests";
import Cookies from "js-cookie";
import { AuthContext } from "./auth";

const ProfileContext = createContext();

const ProfileContextProvider = ({ children }) => {
  const [profile, setProfile] = useState({});
  const { isLoggedIn, user } = useContext(AuthContext);
  const username = user?.username;

  const updateProfile = useCallback((newData) => {
    setProfile(newData || {});
  }, []);
  
  const getProfile = useCallback(async () => {
    try {
      const user = Cookies.get("vaghfnamaUser");
      if (!user) {
        setProfile({});
        return;
      }

      const fetchedProfile = await profileFetcher.get();
      setProfile(fetchedProfile);
    } catch(err) {
      console.error(err);
    }
  }, []);
  
  useEffect(() => {
    if (isLoggedIn && username) {
      getProfile();
    } else {
      setProfile({});
    }
  }, [isLoggedIn, username, getProfile]);

  const contextValue = useMemo(() => ({
    profile,
    updateProfile,
    getProfile,
  }), [profile, updateProfile, getProfile]);

  return (
    <ProfileContext.Provider value={contextValue}>
      {children}
    </ProfileContext.Provider>
  );
};

export { ProfileContext, ProfileContextProvider };
